module.exports = __webpack_public_path__ + "static/media/gts34.a2db3421.png";